/* eslint-disable no-underscore-dangle */
import React from 'react';
import { MultiSelector } from '@leverege/ui-elements';
import S from './StringComparatorMultiEditor.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default class StringComparatorMultiEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: []
    };
    this.searchCharacterMin = props.searchCharacterMin != null ? props.searchCharacterMin : 0;
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    if (this.searchCharacterMin === 0) {
      this.onSearch({
        value: ''
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidUpdate(prevProps) {
    const {
      suggestor
    } = this.props;
    const {
      suggestor: pSuggestor
    } = prevProps;
    if (suggestor !== pSuggestor) {
      this.onSearch({
        value: ''
      });
    }
  }
  onSearch = async ({
    value
  }) => {
    const {
      suggestor
    } = this.props;
    const {
      suggestions
    } = this.state;
    if (value?.length >= this.searchCharacterMin) {
      const suggestions = suggestor && (await suggestor.suggest(value)) || [];
      if (this._isMounted) {
        this.setState({
          suggestions: suggestions.map(s => {
            return typeof s === 'object' ? s : {
              value: s,
              name: s
            };
          })
        });
      }
    } else if (suggestions?.length !== 0) {
      this.setState({
        suggestions: []
      });
    }
  };
  onChange = evt => {
    const {
      onChange
    } = this.props;
    onChange?.(evt);
    this.onSearch({
      value: ''
    });
  };
  render() {
    const {
      value,
      eventData,
      float,
      type,
      allowCreate = true,
      suggestor,
      variant
    } = this.props;
    const {
      suggestions
    } = this.state;
    const v = variant || 'condition';
    return /*#__PURE__*/_jsx(MultiSelector, {
      className: S.selector,
      valueNameAccessor: suggestor?.getNameFor,
      float: float,
      type: type,
      showFilter: true,
      showSelectAll: false,
      variant: v,
      toggleVariant: v,
      allowCreate: allowCreate,
      values: suggestions,
      value: value,
      eventData: eventData,
      onChangeFilter: this.onSearch,
      onChange: this.onChange,
      clearSearchOnSelect: true
    });
  }
}